import * as partsReturnsOrders from './returnOrders';
import * as returnClaim from './returnClaim';

const reducers = {
  ...partsReturnsOrders,
  ...returnClaim,
};

export default reducers;
